<template>
    <div class="w-full flex items-start gap-x-5">
        <div class="rounded-lg min-w-[30%] bg-white p-10 text-black">
            <h2 class="text-2xl font-extralight underline">Remplir les champs suivants :</h2>
            <form @submit.prevent="saveForm" class="mt-8">
                <div class="w-full flex flex-col items-start ">
                    <label for="name" class="font-light" >Nom<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.nom" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="prenom" class="font-light" >Prenom<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.prenom" placeholder="Doe" name="prenom" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="debut" class="font-light" >Début congé<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.startDate" placeholder="" name="debut" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="fin" class="font-light" >Fin congé<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.endDate" placeholder="" name="fin" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="heure" class="font-light" >Heure de reprise<span class="text-[#f44545]">*</span></label>
                    <input type="time" v-model="form.returnTime" placeholder="" name="heure" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                    <button type="submit" :disabled="asSend" class="w-full mt-8 py-3 bg-[#5357ec] text-white rounded-md">
                        <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                        <span v-if="!asSend">Enregistrer</span>
                    </button>
            </form>
        </div>
        <div class="rounded-lg grow min-h-[850px] bg-white">
            <div class="max-w-xl mx-auto bg-white shadow-lg rounded-lg p-6 mt-10">
                <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div>
                    <p class="text-gray-700 mb-4">Date:</p>
                    <h2 class="text-xl font-bold text-center mb-4">Subject: Salary Domiciliation</h2>

                    <div class="mb-4">
                        <p class="text-gray-700 mb-4">
                            To President Saliou Toure<br>
                            BP 564 Grand-Bassam
                        </p>
                        <p class="text-gray-700 mb-4">
                            Dear Mr. President,
                        </p>
                        <p class="text-gray-700 mb-4">
                            I have the honor to request, through this letter, that you kindly transfer the entirety of my monthly salary and any other remuneration owed to me to my bank account held with [Name of the Bank], account number N° [Account Number].
                        </p>
                        <p class="text-gray-700 mb-4">
                            This request for salary domiciliation also applies to any amounts you may owe me in relation to the termination of our professional relationship, if applicable. [cite: 1, 2]
                        </p>
                        <p class="text-gray-700">
                            My salary domiciliation instructions are permanent and can only be revoked with the written and formal consent of the [Name of the Bank] management. [cite: 3]
                        </p>
                        <p class="text-gray-700 mt-4">
                            Please accept, Mr. President, the expression of my deepest respect.
                        </p>
                    </div>

                    <div>
                        <p class="text-gray-700">
                            [Name, position, department and Signature of the requester] [cite: 4]
                        </p>
                    </div>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "SalaryDomiciliation",
    components: {Loader2},
    data() {
        return {
            asSend: false,
            form: {
                nom: null,
                prenom: null,
                startDate: null,
                endDate: null,
                returnTime: null
            }
        };
    },
    methods: {
        clearForm() {
            this.form.nom = null;
            this.form.prenom = null;
            this.form.startDate = null;
            this.form.endDate = null;
            this.form.returnTime = null;
        },
        saveForm(){
            this.asSend = true;
            const data = {
                "content" : JSON.stringify(this.form),
                "doc_id":3,
                "user_id": localStorage.getItem("userId") ?? this.$store.getters.userId
            }
            API.post("user-docs", data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000)
                        this.clearForm();
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>